import { useState } from 'react';
import '../App.scss';
import { Button } from '@mui/base/Button';
import { TextField } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import { AuthClient, ResetPasswordModel } from '../types';
import { createClient } from "../api/clients";

function ResetPassword() {
  const navigate = useNavigate();
  const location = useLocation();

  const params = new URLSearchParams(location.search);
  const token = params.get('token') || '';

  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [errorMessage, setErrorMessage] = useState<string | null>(null);

  const authClient = createClient(AuthClient);

  const handleSubmit = async (e: any) => {
    e.preventDefault();
    setErrorMessage(null);

    if (!token) {
      setErrorMessage('This password reset link is invalid.');
      return;
    }

    if (!password) {
      setErrorMessage('Please enter a new password.');
      return;
    }

    if (password.length < 12) {
      setErrorMessage('Your password must be at least 12 characters long.');
      return;
    }

    if (password !== confirmPassword) {
      setErrorMessage('The passwords do not match.');
      return;
    }

    const request: ResetPasswordModel = {
      token: token,
      password: password,
      confirmPassword: confirmPassword
    };

    try {
      await authClient.resetPassword(request);
      navigate('/login', { replace: true, state: { passwordReset: true } });
    } catch (error) {
        setErrorMessage("This password reset link is invalid or has expired.");
    }
  };

  return (
    <div className="main pb-4 d-flex flex-column align-items-center">
      <h4 className="mb-6">Choose a password</h4>

      <form onSubmit={handleSubmit} className="d-flex flex-column align-items-center">
        <TextField
          id="password"
          label="New password"
          variant="outlined"
          className="mb-4"
          type="password"
          style={{ minWidth: '300px' }}
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          
        />

        <TextField
          id="confirm-password"
          label="Confirm new password"
          variant="outlined"
          className="mb-4"
          type="password"
          style={{ minWidth: '300px' }}
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
          
        />

        {errorMessage && (
          <div className="form-error mb-3">
            {errorMessage}
          </div>
        )}

        <Button type="submit" className="styled-button mb-4" id="btn-reset-password">
          Reset password
        </Button>
      </form>
    </div>
  );
}

export default ResetPassword;
